import React, { useEffect } from 'react';
import { useAuthContext } from 'AuthContext';
import SpinnerComponent from 'components/SpinnerComponent';

const LoginComponent: React.FunctionComponent = () => {
  const { login } = useAuthContext();

  useEffect(() => {
    login();
  }, [login]);

  return <SpinnerComponent visible={true} />;
};

export default LoginComponent;
